import { Injectable } from '@angular/core';
import { BaseReportService } from '@app/api/api-services/base-report.service';
import {
  TraineeHoursReportRequestApiModel,
  TraineeHoursReportApiModel,
  TraineeHoursReportFiltersApiModel
} from '@app/api/api-models';

@Injectable()
export class TraineeHoursReportService extends BaseReportService<
  TraineeHoursReportFiltersApiModel,
  TraineeHoursReportRequestApiModel,
  TraineeHoursReportApiModel
> {
  public readonly apiUrl = 'reports/trainee-hours';
}
